"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = void 0;
var CustomQuestionType;
(function (CustomQuestionType) {
    CustomQuestionType["TEXT"] = "TEXT";
    CustomQuestionType["RADIO"] = "RADIO";
    CustomQuestionType["SELECT"] = "SELECT";
    CustomQuestionType["AUTOCOMPLETE"] = "AUTOCOMPLETE";
})(CustomQuestionType || (CustomQuestionType = {}));
var Template;
(function (Template) {
    Template["TET"] = "TET";
    Template["IJS"] = "IJS";
    Template["PYT"] = "PYT";
    Template["EDV"] = "EDV";
    Template["LEVEL_ONE"] = "LEVEL_ONE";
    Template["INTEREST"] = "INTEREST";
})(Template || (Template = {}));
var Type;
(function (Type) {
    Type["TALENT_ACADEMY"] = "TALENT_ACADEMY";
    Type["UPLOAD_MEDIAS"] = "UPLOAD_MEDIAS";
    Type["SUBSCRIPTION"] = "SUBSCRIPTION";
    Type["WORKSHOP"] = "WORKSHOP";
    Type["EVALUATE"] = "EVALUATE";
    Type["INTERVIEW"] = "INTERVIEW";
    Type["TEST"] = "TEST";
})(Type || (Type = {}));
var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["ACTIVE"] = "ACTIVE";
    Status["FINISHED"] = "FINISHED";
    Status["STOPPED"] = "STOPPED";
    Status["DISABLED"] = "DISABLED";
})(Status || (Status = {}));
exports.enums = {
    status: Status,
    type: Type,
    template: Template,
    customQuestionType: CustomQuestionType,
};
//# sourceMappingURL=ClassVacancy.js.map